import React from "react";

export default function Section({ id, eyebrow, title, children }) {
  return (
    <section className="section" id={id}>
      <div className="section-head">
        <span className="section-eyebrow">{eyebrow}</span>
        <h2 className="section-title">{title}</h2>
        <span className="section-rule"></span>
      </div>
      {children}
    </section>
  );
}
